window.addEventListener('load', function () {

  // let languageButton = document.getElementById('block-dropdownlanguage').querySelector('.language-link');
  // languageButton.classList.remove('dropbutton');

  // let links = document.getElementById('block-dropdownlanguage').querySelectorAll('.dropbutton-action.secondary-action');

  // let parent = links[0].parentNode;

  // let linkContainer = document.createElement('ul');

  // parent.appendChild(linkContainer);

  // let dropdownButton = document.getElementById('block-dropdownlanguage').querySelector('.dropbutton-toggle');

  // dropdownButton.id = 'dropdownLanguageSwitcher';
  // dropdownButton.setAttribute('data-bs-toggle', 'dropdown');
  // dropdownButton.setAttribute('aria-expanded', 'false');

  // linkContainer.className = 'dropdown-menu';
  // linkContainer.setAttribute('aria-labelledby', 'dropdownLanguageSwitcher');

  // for (let i = 0; i < links.length; i++)
  //   linkContainer.appendChild(links[i]);


    /*languageButton.addEventListener('click', function (event) {
      dropdownButton.click();
      event.stopPropagation();
    	event.preventDefault();
    });*/

  let searchForm = document.getElementById('search-block-form');
  let searchFormCloseButton = document.getElementById('search-block-form').querySelector('.search-close-button');
  let searchIcon = document.getElementById('block-kec-stark-search').querySelector('.search-icon');

  // var searchicon = $('.search-block-form .search-form');
// searchicon.click(function(){
//   if(searchicon.css('display', 'flex')){
//     searchicon.css('display', 'none');
//   }
//   else {
//     searchicon.css('display', 'flex');
//   }

// });

  searchFormCloseButton.addEventListener('click', function (event) {
    searchForm.classList.remove('animate__fadeInDown','show');
    searchForm.classList.add('animate__fadeInUp','hide');
    searchForm.setAttribute('hidden', 'true');
  });

  console.log('bbb');
  searchIcon.addEventListener('click', function (event) {

    console.log('aaaa');

     if (searchForm.classList.contains('hide')) {
       searchForm.removeAttribute('hidden');
       searchForm.classList.remove('animate__fadeInUp','hide');
       searchForm.classList.add('animate__fadeInDown','show');
     } else {
       searchForm.classList.remove('animate__fadeInDown','show');
       searchForm.classList.add('animate__fadeInUp', 'hide');
       searchForm.setAttribute('hidden', 'true');
     }
  });


  document.getElementById('block-secondarymenu').querySelectorAll('.collapsed.dropdown-item').forEach((elem) => {
    elem.addEventListener('click', function (event) {
      let menu = this.nextElementSibling;

      if (elem.classList.contains('show')) {
        menu.classList.remove('animate__fadeInLeft');
        menu.classList.add('animate__fadeOutLeft');
      } else {
        menu.classList.remove('animate__fadeOutLeft');
        menu.classList.add('animate__fadeInLeft');
      }

    });
  })

  document.querySelectorAll('.navbar-submenu.dropdown-menu .nav-item.nav-child.text-caption .btn.btn-secondary').forEach((elem) => {
    elem.parentNode.classList.add('hide-after');
  })

}, false);
